module.exports = __webpack_public_path__ + "img/signature-gris.686bd455.png";